import { render } from "./App.vue?vue&type=template&id=6bcd2631"
const script = {}

import exportComponent from "/data/www/html/loic.v2.isavethedate.fr/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__